import { render, staticRenderFns } from "./ShowPoster.vue?vue&type=template&id=41e2b846&scoped=true&"
import script from "./ShowPoster.vue?vue&type=script&lang=js&"
export * from "./ShowPoster.vue?vue&type=script&lang=js&"
import style0 from "./ShowPoster.vue?vue&type=style&index=0&id=41e2b846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e2b846",
  null
  
)

export default component.exports